import React, { createContext, useCallback, useState, useContext } from 'react';
import { normalizeVisualStyleKey } from '../utils/visualStyleReferences';

const StyleContext = createContext();

export const StyleProvider = ({ children }) => {
  const [currentStyle, setCurrentStyleState] = useState(() => {
    return normalizeVisualStyleKey(localStorage.getItem('gen_style'), 'modern_cdrama');
  });

  const setCurrentStyle = useCallback((style, options = {}) => {
    const normalized = normalizeVisualStyleKey(style, 'modern_cdrama');
    setCurrentStyleState(normalized);
    if (options.persist !== false) {
      localStorage.setItem('gen_style', normalized);
    }
  }, []);

  return (
    <StyleContext.Provider value={{ currentStyle, setCurrentStyle }}>
      {children}
    </StyleContext.Provider>
  );
};

export const useStyle = () => {
  const context = useContext(StyleContext);
  if (!context) {
    throw new Error('useStyle must be used within a StyleProvider');
  }
  return context;
};
